import { Button } from '@kontentino/ui';
import { create } from 'zustand';
import { useTranslation } from 'react-i18next';
import CelebrationModalBase from 'app/components/modals/shared/CelebrationModalBase';

interface FirstApprovalRequestedModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useFirstApprovalRequestedModal =
  create<FirstApprovalRequestedModalState>()((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }));

const FirstApprovalRequestedModal = () => {
  const { t } = useTranslation();
  const isOpen = useFirstApprovalRequestedModal((state) => state.isOpen);
  const close = useFirstApprovalRequestedModal((state) => state.close);

  if (!isOpen) {
    return null;
  }

  return (
    <CelebrationModalBase
      open={isOpen}
      onClose={close}
      dataName="first-approval-requested-modal"
      dataCy="first-approval-requested-modal"
      image={
        <div className="tw-relative tw-w-full tw-overflow-hidden tw-rounded-lg">
          <div style={{ paddingBottom: '56.25%' }} />
          <iframe
            className="tw-absolute tw-inset-0 tw-h-full tw-w-full"
            src="https://www.youtube-nocookie.com/embed/hIDWH-C-w10?rel=0&modestbranding=1&playsinline=1&controls=1&iv_load_policy=3"
            title={t('firstApprovalRequestedModal.videoTitle', {
              defaultValue: 'Sending posts for approval',
            })}
            frameBorder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            sandbox="allow-same-origin allow-scripts allow-presentation"
            allowFullScreen
          />
        </div>
      }
      title={t('firstApprovalRequestedModal.title', {
        defaultValue: `Off it goes! Sent for approval. 🙌`,
      })}
      description={t('firstApprovalRequestedModal.description', {
        defaultValue:
          "Your first approval request is on its way. We'll let you know as soon as there's feedback, so you can keep things moving.",
      })}
      button={
        <Button
          className="tw-w-full"
          onClick={close}
          variant="primary"
          size="large"
          data-name="first-approval-requested_got-it-button"
          data-cy="first-approval-requested_got-it-button"
        >
          {t('firstApprovalRequestedModal.cta', {
            defaultValue: 'Got it',
          })}
        </Button>
      }
    />
  );
};

export default FirstApprovalRequestedModal;
